import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import React from 'react';
import { useSelector } from 'react-redux';
import { Dropdown, Field, RadioGroup } from '../../../../../Core';
import { ListFieldSection } from '../../../../../Layout';
import { IWorksheetComponent } from '../../../../Core/types';

let DispersantSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const isDispersantUsed =
    (useSelector(createWorksheetSelector!('Preparation.IsDispersantUsed')) as boolean | undefined) ?? false;

  return (
    <ListFieldSection>
      <Field
        input={<RadioGroup />}
        label="Dispersant Used"
        name="Preparation.IsDispersantUsed"
        options={[
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]}
      />
      <Field
        input={<Dropdown />}
        label="Dispersion Apparatus Used"
        name="Preparation.DispersionApparatus"
        visible={isDispersantUsed}
        simpleValue
      />
    </ListFieldSection>
  );
};

DispersantSection = withInjectedProps(DispersantSection);

export default DispersantSection;
export { DispersantSection };
